module.exports = __webpack_public_path__ + "img/product-example.570a259f.svg";